export const FIRST_PAGE = 1

export const LIMIT_PAGES = 32

export const TOTAL_PRODUCTS_PER_PAGE = 20
